import { useUpdateCommunication } from './useCommunications';
import { useUser } from '../providers/UserProvider';
import { useToast } from '../providers/ToastProvider';
import type { Communication } from '../services/communications';

/** Inline assign/unassign for a thread row. Mirrors useCaseAssignment (work
 *  queue); no team scope here, so callers leave the picker's roles unset. */
export function useCommunicationAssignment(communication: Communication) {
    const { user } = useUser();
    const { showToast } = useToast();
    const updateCommunication = useUpdateCommunication();

    const setAssignee = async (assigneeEmail: string | null, failureMessage: string) => {
        try {
            await updateCommunication.mutateAsync({
                id: communication.id,
                patch: { assigneeEmail }
            });
        } catch {
            showToast(failureMessage, 'error');
        }
    };

    return {
        currentUserEmail: user?.email ?? '',
        isSaving: updateCommunication.isPending,
        handleAssign: (email: string) => void setAssignee(email, 'Failed to assign communication.'),
        handleUnassign: () => void setAssignee(null, 'Failed to unassign communication.')
    };
}
